import type { Spacings } from '../types/spacing';
import type { BreakpointValues } from '../types/breakpoints';
import type { Mixin } from '../types/mixin';
import { mapToBreakpoints } from './mapToBreakpoints';

export type SpaceProp = BreakpointValues<Spacings>;

/**
 * Get CSS declaration for a particular spacing, optionally for particular breakpoint(s)
 * @param {string|object} values Spacing value, optionally for a given breakpoint (e.g. 0.5 or {m: '0.5'})
 * @param {string} prop Which CSS property to use (e.g. margin-bottom)
 * @returns {string} CSS declaration for the desired color / breaking point
 */
const spaceProp =
  (steps: BreakpointValues<Spacings> | undefined, prop = 'margin-bottom'): Mixin =>
  ({ theme }) => {
    if (!steps && steps !== 0) return '';
    return mapToBreakpoints<Spacings>(steps, (step): any => {
      return `
        ${prop}: ${theme.spacing[step]};
      `;
    });
  };

export { spaceProp };
